import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    root: {
        '&.MuiTypography-body1': {
            display: 'flex',
            fontFamily: 'AvenirNextWorld Regular',
            fontSize: '14px',
            color: '#140F4B',
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
        },
        '&.MuiGrid-container':{
            flexWrap: 'nowrap',
        }
    },
});
